module.exports = __webpack_public_path__ + "static/media/tuev-privacy.49f3df0e.svg";